import { Monitor, Moon, Sun } from 'lucide-react';
import { type ReactNode, useState } from 'react';

import { IconHint } from '../hint';
import { Button } from '../../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '../../ui/dropdown-menu';
import { sh } from './messages';
import { applyThemeChoice, isThemeChoice, readThemeChoice, type ThemeChoice } from './themeChoice';

export function ThemeToggle(): ReactNode {
  const [choice, setChoice] = useState<ThemeChoice>(readThemeChoice);

  function choose(next: string): void {
    if (!isThemeChoice(next)) return;
    setChoice(next);
    applyThemeChoice(next);
  }

  const Icon = choice === 'dark' ? Moon : choice === 'light' ? Sun : Monitor;

  return (
    // `modal={false}`: the default calls Radix's `hideOthers` on the trigger's
    // whole ancestor tree while open, which includes the trigger itself --
    // still natively focusable, and now inside an `aria-hidden` subtree, which
    // is exactly the `aria-hidden-focus` violation axe checks for. This menu
    // is not a dialog; it does not need outside pointer events blocked either.
    <DropdownMenu modal={false}>
      <IconHint label={sh('theme.label')}>
        <DropdownMenuTrigger asChild>
          <Button type="button" variant="ghost" size="icon-sm">
            <Icon aria-hidden />
          </Button>
        </DropdownMenuTrigger>
      </IconHint>
      <DropdownMenuContent align="start">
        <DropdownMenuRadioGroup value={choice} onValueChange={choose}>
          <DropdownMenuRadioItem value="light">{sh('theme.light')}</DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="dark">{sh('theme.dark')}</DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="system">{sh('theme.system')}</DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
